import ApiService from "./api.service";
import mainStore from "../store/mainStore";

class CountryService extends ApiService {
    async getCountries() {
        const response = await this.get("api/meeting/country");
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        mainStore.commit("setCountries", response.data);
        return response;
    }
}

export default new CountryService();
